import Reveal, { Eyebrow } from "./Reveal";

const AGENTS = [
  { name: "RPI Verification", does: "Confirms the right party before any payment talk. No payment discussion until identity is confirmed.", dispositions: "8 dispositions" },
  { name: "Payment Reminder", does: "Calls before the due date. A gentle nudge; intent confirmed; payment date captured.", dispositions: "9 dispositions" },
  { name: "Promise-to-Pay", does: "Agrees a specific date and amount. The promise is recorded.", dispositions: "12 dispositions" },
  { name: "Settlement", does: "Principal + minimal charges. Settlement letter after approval.", dispositions: "11 dispositions" },
  { name: "Broken-Promise", does: "Follows up when a promise breaks, and negotiates a new one.", dispositions: "11 dispositions" },
];

const STATS = [
  { value: "76%", label: "of contacts never connected at all" },
  { value: "33%", label: "of settlement accounts were the wrong person" },
  { value: "23.6%", label: "connect rate — 2,369 attempts on 832 contacts" },
];

const Collections = () => (
  <section id="collections" data-testid="collections-section" className="py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="max-w-3xl">
        <Eyebrow>Live today · The collections pack</Eyebrow>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-4 leading-[1.08]">
          The pack changes who calls — not the shape of your business.
        </h2>
        <p className="text-zinc-600 mt-6 leading-relaxed">
          Same lists in, same files out. In a real portfolio sample (QGBS, Audatec export), this is
          what the dialling looked like before the pack took over the calling:
        </p>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-12">
        {STATS.map((s, i) => (
          <Reveal key={s.value} delay={i * 0.08}>
            <div data-testid={`collections-stat-${i + 1}`} className="border-t-2 border-[#09090B] pt-5">
              <p className="font-display font-extrabold text-4xl sm:text-5xl tracking-tight text-[#09090B]">
                {s.value}
              </p>
              <p className="text-zinc-600 text-sm mt-2 leading-relaxed">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1} className="mt-14">
        <div className="rounded-2xl border border-zinc-200 bg-white overflow-hidden shadow-sm">
          <div className="px-6 sm:px-8 py-5 border-b border-zinc-200 flex items-center justify-between">
            <h3 className="font-display font-bold text-lg sm:text-xl">Five agents, one campaign</h3>
            <span className="font-mono2 text-[10px] uppercase tracking-widest text-zinc-400">Collections pack</span>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-left min-w-[680px]" data-testid="collections-agents-table">
              <thead>
                <tr className="border-b border-zinc-200">
                  <th className="font-mono2 text-[10px] uppercase tracking-widest text-zinc-400 font-medium px-6 sm:px-8 py-4">Agent</th>
                  <th className="font-mono2 text-[10px] uppercase tracking-widest text-zinc-400 font-medium px-6 py-4">What it does</th>
                  <th className="font-mono2 text-[10px] uppercase tracking-widest text-zinc-400 font-medium px-6 sm:px-8 py-4 text-right">Outcomes</th>
                </tr>
              </thead>
              <tbody>
                {AGENTS.map((a, i) => (
                  <tr
                    key={a.name}
                    data-testid={`agent-row-${i + 1}`}
                    className="border-b border-zinc-100 last:border-0 hover:bg-[#EFF6FF]/60 transition-colors duration-300"
                  >
                    <td className="px-6 sm:px-8 py-5 font-display font-bold text-zinc-900 whitespace-nowrap">{a.name}</td>
                    <td className="px-6 py-5 text-zinc-600 text-sm leading-relaxed">{a.does}</td>
                    <td className="px-6 sm:px-8 py-5 text-right">
                      <span className="font-mono2 text-xs text-[#2563EB] whitespace-nowrap">{a.dispositions}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.15} className="mt-6">
        <p className="text-sm text-zinc-500 leading-relaxed max-w-3xl border-l-2 border-[#2563EB] pl-4">
          Collections-pack honesty: kept vs broken promises need your payment data — payment truth
          lives with the bank. The platform works the list you provide.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Collections;
